import { useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import useMediaQuery from "@mui/material/useMediaQuery";
import InputLabel from "@mui/material/InputLabel";
import Pagination from "@mui/material/Pagination";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import DialogData from "./DialogData";
import DeleteWord from "./DeleteWord";
import EditWord from "./EditWord";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(name, data) {
  return { name, data };
}

// دیتاهای مورد نیاز و اسم نمایشی آنها را تعین میکند
const neededData = {
  _id: "ویرایش و حذف",
  fromLang: "زبان لغت",
  toLang: "زبان ترجمه",
  word: "لغت",
  meanings: "ترجمه ها",
  movieName: "نام فیلم",
  season: "شماره فصل",
  episode: "شماره قسمت",
  groups: "گروه های ذخیره شده",
  createdAt: "تاریخ ذخیره لفت",
};

export default function MyWordsList(props) {
  const {
    fetchedData,
    pageAndPerPage,
    setNumberPageAndPerPage,
    deleteWordFromFromBack,
    editWordInBack,
  } = props;

  const RecivedData = fetchedData["data"]["data"]["docs"];
  // هر مجموعه از دیتا را برای هر جدول درون یک المنت آرایه از listOfTable میریزد
  let listOfTable = RecivedData.map((el, index) => {
    const rowOfTableData = [];
    for (const property in el) {
      // دیتاهایی که در neededData گفته ایم نیاز داریم را جدا می کند
      if (neededData[property]) {
        // دیتاهایی که  بصورت تاریخ هستند - باید خودمان مشخص کنیم-. را تبدیل به تاریخ شمسی میکند
        if (
          property == "buyingDate" ||
          property == "startingDate" ||
          property == "endingDate" ||
          property == "createdAt"
        ) {
          const date = new DateObject({
            date: el[property],
            calendar: persian,
            locale: persian_fa,
          });
          rowOfTableData.push(
            createData(neededData[property], {
              name: property,
              data: date.format(),
            })
          );
        } else if (property == "validation") {
          rowOfTableData.push(
            createData(neededData[property], {
              name: property,
              data: el[property] ? "معتبر تا زمان اتمام پکیج" : "نامعتبر",
            })
          );
        } else if (property == "toLang" || property == "fromLang") {
          const showingData = languagesList[el[property]];
          rowOfTableData.push(
            createData(neededData[property], {
              name: property,
              data: showingData,
            })
          );
        } else
          rowOfTableData.push(
            createData(neededData[property], {
              name: property,
              data: el[property],
            })
          );
      }
    }
    return rowOfTableData;
  });

  // اگر سایز صفحه از 600 پیکسل کوچکتر شود مقدار ترو برمیگرداند
  const detectSize600px = useMediaQuery("(min-width:600px)");

  const [openDialogContent, setOpenDialogContent] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogType, setDialogType] = useState("");
  const [dialogContentData, setDialogContentData] = useState("");

  const handleOpenDialogContent = () => {
    setOpenDialogContent(true);
  };
  const handleCloseDialogContent = () => {
    setOpenDialogContent(false);
  };

  //  فانکشنی برای نشان دادن پاپ آپ وابسته به کلیک بر روی دکمه های مختلف در جدول
  const setDialog = (type, dataContent) => {
    if (type == "deleteWord") {
      // let data = JSON.parse(e);
      // data.forEach((e) => {
      //   console.log(e);
      // });
      setDialogTitle("حذف لغت");
      setDialogType("deleteWord");
      handleOpenDialogContent();
      setDialogContentData(
        <DeleteWord
          dataContent={dataContent}
          handleCloseDialogContent={handleCloseDialogContent}
          deleteWordFromFromBack={deleteWordFromFromBack}
        />
      );
    } else if (type == "edit") {
      // let data = JSON.parse(e);
      // data.forEach((e) => {
      //   console.log(e);
      // });
      setDialogTitle("ویرایش لغت");
      setDialogType("editword");
      handleOpenDialogContent();
      setDialogContentData(
        <EditWord
          dataContent={dataContent}
          handleCloseDialogContent={handleCloseDialogContent}
          editWordInBack={editWordInBack}
        />
      );
    } else return <Button> adsadas asd asd</Button>;
  };

  const showArrayInTable = (value) => {
    let data = "";
    value.forEach((content) => {
      data += `${content} , `;
    });
    // console.log("value", data);
    return data;
  };

  // اطلاعات هر سطر را بر میگرداند و در صورت نیاز قبل از برگرداندن تغیراتی روی دیتا انجام می دهیم
  const showRowData = (index, data) => {
    const { name, data: content } = data;
    // console.log("00000000000", content);
    if (name == "status") {
      return (
        <StyledTableCell align="left">
          <Button
            data-status={JSON.stringify(content)}
            onClick={(e) => {
              setDialog("DeleteWord", e.target.dataset.status);
            }}
          >
            مشاهده
          </Button>
        </StyledTableCell>
      );
    } else if (name == "_id")
      return (
        <StyledTableCell align="left">
          <IconButton
            aria-label="delete"
            color="warning"
            onClick={(e) => {
              // console.log("00asasas", listOfTable[index]);
              setDialog("edit", listOfTable[index]);
            }}
          >
            <ModeEditIcon />
          </IconButton>
          <IconButton
            aria-label="delete"
            color="error"
            data-id={JSON.stringify(content)}
            onClick={(e) => {
              setDialog("deleteWord", content);
            }}
          >
            <DeleteForeverIcon />
          </IconButton>

          {/* <Button
            data-id={JSON.stringify(content)}
            onClick={(e) => {
              console.log("asdasdasd", e.target.dataset.id);
              setDialog("deleteWord", e.target.dataset.id);
            }}
          >
            حذف لغت
          </Button> */}
        </StyledTableCell>
      );
    else if (name == "meanings") {
      return (
        <StyledTableCell align="left">
          {showArrayInTable(content)}
        </StyledTableCell>
      );
    } else if (name == "groups") {
      return (
        <StyledTableCell align="left">
          {showArrayInTable(content)}
        </StyledTableCell>
      );
    } else {
      return <StyledTableCell align="left">{content}</StyledTableCell>;
    }
  };

  // _id: "آی دی",
  // fromLang: "زبان لغت",
  // toLang: "زبان ترجمه",
  // word: "لغت",
  // meanings: "ترجمه ها",
  // movieName: "نام فیلم",
  // season: "شماره فصل",
  // episode: "شماره قسمت",
  // groups: "گروه های ذخیره شده",
  // createdAt: "تاریخ ذخیره لفت"

  return (
    <>
      <DialogData
        openDialogContent={openDialogContent}
        handleCloseDialogContent={handleCloseDialogContent}
        dialogTitle={dialogTitle}
        dialogType={dialogType}
      >
        {dialogContentData}
      </DialogData>
      <Box>
        {listOfTable.map((oneRow, index) => (
          <TableContainer
            key={`MainTable-${index}`}
            component={Paper}
            sx={{ mb: 1 }}
          >
            <Table sx={{ minWidth: 10 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    sx={{ width: detectSize600px ? "25%" : "50%" }}
                  ></StyledTableCell>
                  <StyledTableCell
                    sx={{ width: detectSize600px ? "75%" : "50%" }}
                    align="left"
                  ></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {oneRow.map((row) => (
                  <StyledTableRow key={row.name}>
                    <StyledTableCell component="th" scope="row">
                      {row.name}
                    </StyledTableCell>
                    {showRowData(index, row.data)}
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          // <StyledTableRow key={row.name}>
          //   <StyledTableCell component="th" scope="row">
          //     {row.name}
          //   </StyledTableCell>
          //   <StyledTableCell align="left">{row.data}</StyledTableCell>
          // </StyledTableRow>
        ))}
        <Box sx={{ display: "flex", alignItems: "baseline" }}>
          <Pagination
            count={pageAndPerPage.totalPages}
            siblingCount={0}
            color="primary"
            hideNextButton={pageAndPerPage.hasNextPage}
            hidePrevButton={pageAndPerPage.hasPrevPage}
            // totalPages:0,
            // hasNextPage:false,
            // hasPrevPage:false,
            // page:0,
            // totalDocs:0,
            // totalPages: 0

            onChange={(e, value) => {
              setNumberPageAndPerPage("page", value);
            }}
          />
          {pageAndPerPage.totalPages == 0 ? null : (
            <>
              تعداد کل:{pageAndPerPage.totalDocs}
              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel id="demo-select-small">تعداد در هر صفحه</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  defaultValue={5}
                  value={pageAndPerPage.perPage}
                  label="تعداد در هر صفحه"
                  onChange={(e) => {
                    setNumberPageAndPerPage("perPage", e.target.value);
                  }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={35}>35</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
            </>
          )}
        </Box>
      </Box>
    </>
  );
}

const languagesList = {
  ab: "Abkhazian",
  aa: "Afar",
  af: "Afrikaans",
  ak: "Akan",
  sq: "Albanian",
  am: "Amharic",
  ar: "Arabic",
  an: "Aragonese",
  hy: "Armenian",
  as: "Assamese",
  av: "Avaric",
  ae: "Avestan",
  ay: "Aymara",
  az: "Azerbaijani",
  bm: "Bambara",
  ba: "Bashkir",
  eu: "Basque",
  be: "Belarusian",
  bn: "Bengali",
  bh: "Bihari languages",
  bi: "Bislama",
  bs: "Bosnian",
  br: "Breton",
  bg: "Bulgarian",
  my: "Burmese",
  ca: "Catalan, Valencian",
  km: "Central Khmer",
  ch: "Chamorro",
  ce: "Chechen",
  ny: "Chichewa, Chewa, Nyanja",
  zh: "Chinese",
  cu: "Church Slavonic, Old Bulgarian, Old Church Slavonic",
  cv: "Chuvash",
  kw: "Cornish",
  co: "Corsican",
  cr: "Cree",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  dv: "Divehi, Dhivehi, Maldivian",
  nl: "Dutch, Flemish",
  dz: "Dzongkha",
  en: "English",
  eo: "Esperanto",
  et: "Estonian",
  ee: "Ewe",
  fo: "Faroese",
  fj: "Fijian",
  fi: "Finnish",
  fr: "French",
  ff: "Fulah",
  gd: "Gaelic, Scottish Gaelic",
  gl: "Galician",
  lg: "Ganda",
  ka: "Georgian",
  de: "German",
  ki: "Gikuyu, Kikuyu",
  el: "Greek (Modern)",
  kl: "Greenlandic, Kalaallisut",
  gn: "Guarani",
  gu: "Gujarati",
  ht: "Haitian, Haitian Creole",
  ha: "Hausa",
  he: "Hebrew",
  hz: "Herero",
  hi: "Hindi",
  ho: "Hiri Motu",
  hu: "Hungarian",
  is: "Icelandic",
  io: "Ido",
  ig: "Igbo",
  id: "Indonesian",
  ia: "Interlingua (International Auxiliary Language Association)",
  ie: "Interlingue",
  iu: "Inuktitut",
  ik: "Inupiaq",
  ga: "Irish",
  it: "Italian",
  ja: "Japanese",
  jv: "Javanese",
  kn: "Kannada",
  kr: "Kanuri",
  ks: "Kashmiri",
  kk: "Kazakh",
  rw: "Kinyarwanda",
  kv: "Komi",
  kg: "Kongo",
  ko: "Korean",
  kj: "Kwanyama, Kuanyama",
  ku: "Kurdish",
  ky: "Kyrgyz",
  lo: "Lao",
  la: "Latin",
  lv: "Latvian",
  lb: "Letzeburgesch, Luxembourgish",
  li: "Limburgish, Limburgan, Limburger",
  ln: "Lingala",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  mk: "Macedonian",
  mg: "Malagasy",
  ms: "Malay",
  ml: "Malayalam",
  mt: "Maltese",
  gv: "Manx",
  mi: "Maori",
  mr: "Marathi",
  mh: "Marshallese",
  ro: "Moldovan, Moldavian, Romanian",
  mn: "Mongolian",
  na: "Nauru",
  nv: "Navajo, Navaho",
  nd: "Northern Ndebele",
  ng: "Ndonga",
  ne: "Nepali",
  se: "Northern Sami",
  no: "Norwegian",
  nb: "Norwegian Bokmål",
  nn: "Norwegian Nynorsk",
  ii: "Nuosu, Sichuan Yi",
  oc: "Occitan (post 1500)",
  oj: "Ojibwa",
  or: "Oriya",
  om: "Oromo",
  os: "Ossetian, Ossetic",
  pi: "Pali",
  pa: "Panjabi, Punjabi",
  ps: "Pashto, Pushto",
  fa: "Persian",
  pl: "Polish",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  ru: "Russian",
  sm: "Samoan",
  sg: "Sango",
  sa: "Sanskrit",
  sc: "Sardinian",
  sr: "Serbian",
  sn: "Shona",
  sd: "Sindhi",
  si: "Sinhala, Sinhalese",
  sk: "Slovak",
  sl: "Slovenian",
  so: "Somali",
  st: "Sotho, Southern",
  nr: "South Ndebele",
  es: "Spanish, Castilian",
  su: "Sundanese",
  sw: "Swahili",
  ss: "Swati",
  sv: "Swedish",
  tl: "Tagalog",
  ty: "Tahitian",
  tg: "Tajik",
  ta: "Tamil",
  tt: "Tatar",
  te: "Telugu",
  th: "Thai",
  bo: "Tibetan",
  ti: "Tigrinya",
  to: "Tonga (Tonga Islands)",
  ts: "Tsonga",
  tn: "Tswana",
  tr: "Turkish",
  tk: "Turkmen",
  tw: "Twi",
  ug: "Uighur, Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volap_k",
  wa: "Walloon",
  cy: "Welsh",
  fy: "Western Frisian",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang, Chuang",
  zu: "Zulu",
};
